// The deployment shapes this image supports. One dial, read by every regional dependency: the database
// client picks its pools from it, and S3 picks the region its buckets live in.
export const ROUTING_MODE = Object.freeze({
  // One region serves everything. No second pool exists, so nothing is routed, and regional services are
  // reached at AWS_REGION. This is what every deployment runs when the variable is unset.
  primary: 'primary',
  // A full read-only replica of the primary near the caller. Reads go to it, everything else to the primary.
  // The buckets are not replicated, so S3 goes to the primary region.
  edge: 'edge',
  // Table placement decides. Writes to Global tables go to the primary, everything else stays regional, and
  // S3 follows the same Global/Local split per bucket.
  residency: 'residency'
});
